import { Box, Tabs, Tab } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { useState } from "react";

import AlertError from "../../../../common/components/alert_error";
import DefaultFormInput from "../../../../common/components/default_form_input";
import FormContainer from "../../../../common/components/form_container";
import SwitchPrimary from "../../../../common/components/switch_primary";

/**
 * CargoCadastroForm
 */

type Props = {
  cargoId?: number,
  cargoDescricao?: string,
  hookForm: UseFormReturn<any>,
};

export const CargoCadastroForm = ({
  cargoId,
  cargoDescricao,
  hookForm,
}: Props) => {
  const [valueTab, setValueTab] = useState(1);
  return (
    <>
      <div className="div flex flex-col md:flex-row justify-between items-start gap-6">
        <div className="flex gap-2 flex-col items-start">
          <h1 className="text-3xl font-medium text-black dark:text-white">
            {cargoId === 0
              ? "Novo cargo"
              : cargoDescricao}
          </h1>
        </div>
      </div>
      {
        hookForm.formState.errors.root &&
        <div className="w-full">
          <AlertError
            messageErro={hookForm.formState.errors.root.message ?? ""}
            onTryAgain={async () => { }}
            onClose={() => { }} />
        </div>
      }
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{ style: { background: '#009C4E' } }}
          value={valueTab}
          onChange={(_, newValue) => setValueTab(newValue)}>
          <Tab sx={{
            textTransform: "none",
            '&.Mui-selected': {
              color: '#009C4E',
            },
          }} label="Informações Gerais" value={1} />
          <Tab sx={{
            textTransform: "none",
            '&.Mui-selected': {
              color: '#009C4E',
            },
          }} label="Treinamentos" value={2} />
          <Tab sx={{
            textTransform: "none",
            '&.Mui-selected': {
              color: '#009C4E',
            },
          }} label="Habilidades " value={3} />
        </Tabs>
      </Box>
      {
        valueTab === 1 &&
        <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
          <FormContainer arrangement="fullRow" title="Informações básicas">
            <>
              <SwitchPrimary
                onChange={(y) => { }}
                checked={false}
                name="Ativo"
                label={false ? "Ativo" : "Inativo"}
              />

              <DefaultFormInput
                name={'descricao'}
                label="Cargo(Descrição)"
                reactHookForm={hookForm} />
            </>
          </FormContainer>
          <FormContainer
            arrangement="fullRow"
            title="Atribuições, responsabilidades e autoridades">
            <>
              <DefaultFormInput
                name={'atribucoes'}
                label="Atribuições, responsabilidades e autoridades"
                required
                multiline
                minRows={3}
                reactHookForm={hookForm} />
            </>
          </FormContainer>
          <FormContainer
            arrangement="fullRow"
            title="Escolaridade">
            <>
              <DefaultFormInput
                name={'escolaridade'}
                label="Escolaridade"
                multiline
                minRows={3}
                reactHookForm={hookForm} />
            </>
          </FormContainer>
          <FormContainer
            arrangement="fullRow"
            title="Experiência">
            <>
              <DefaultFormInput
                name={'experiencia'}
                label="Experiência"
                multiline
                minRows={3}
                reactHookForm={hookForm} />
            </>
          </FormContainer>
          <FormContainer
            border={false}
            arrangement="fullRow"
            title="Qualificações, conhecimentos e habilitações">
            <>
              <DefaultFormInput
                name={'qualificacoes'}
                label="Qualificações, conhecimentos e habilitações"
                multiline
                minRows={3}
                reactHookForm={hookForm} />
            </>
          </FormContainer>
        </div>
      }
    </>
  );
}